const HIGH_BITRATE_THRESHOLD_MBPS = 54;

function toNumber(value) {
  if (value === null || value === undefined || value === "") return NaN;
  const normalized = String(value).replace(",", ".").trim();
  const num = Number(normalized);
  return Number.isFinite(num) ? num : NaN;
}

function parseFecRatio(value) {
  const text = String(value ?? "").trim().toLowerCase();
  const match = text.match(/^(\d+)\s*\/\s*(\d+)$/);
  if (!match) return NaN;

  const numerator = Number(match[1]);
  const denominator = Number(match[2]);
  if (!Number.isFinite(numerator) || !Number.isFinite(denominator) || denominator === 0) {
    return NaN;
  }

  return numerator / denominator;
}

function bitsFromModulationText(value) {
  const text = String(value ?? "").trim().toLowerCase().replace(/\s+/g, "");
  if (!text) return NaN;
  if (text.includes("qpsk")) return 2;
  if (text.includes("8psk")) return 3;
  if (text.includes("16apsk")) return 4;
  if (text.includes("32apsk")) return 5;
  if (text.includes("64apsk")) return 6;
  return NaN;
}

function inferBitsPerSymbol(tp) {
  const dvb = String(tp?.dvb ?? tp?.DVB ?? "").trim();
  const dvbLower = dvb.toLowerCase();

  // If DVB already contains a concrete modulation string, prefer it.
  const dvbBits = bitsFromModulationText(dvb);
  if (Number.isFinite(dvbBits) && dvb.includes("/")) {
    return dvbBits;
  }

  // Otherwise prefer explicit PSK/modulation fields from the source.
  const modulationBits = bitsFromModulationText(tp?.modulation ?? tp?.Modulation ?? tp?.PSK);
  if (Number.isFinite(modulationBits)) {
    return modulationBits;
  }

  // Last resort: infer a default from the DVB standard only.
  if (dvbLower.includes("dvb-s2x")) return 3;
  if (dvbLower.includes("dvb-s2")) return 3;
  if (dvbLower.includes("dvb-s")) return 2;

  return NaN;
}

export function estimateBitrateMbps(tp) {
  const srKsps = toNumber(tp?.symbolrate_kSps);
  const fec = parseFecRatio(tp?.fec ?? tp?.FEC);
  const bitsPerSymbol = inferBitsPerSymbol(tp);

  if (!Number.isFinite(srKsps) || !Number.isFinite(fec) || !Number.isFinite(bitsPerSymbol)) {
    return NaN;
  }

  const transportOverheadFactor = 188 / 204;
  const mbps = (srKsps * bitsPerSymbol * fec * transportOverheadFactor) / 1000;
  return Number.isFinite(mbps) ? mbps : NaN;
}

export function isHighBitrateTp(tp, thresholdMbps = HIGH_BITRATE_THRESHOLD_MBPS) {
  const mbps = estimateBitrateMbps(tp);
  return Number.isFinite(mbps) && mbps > thresholdMbps;
}

export function getBitrateRowTitle(tp) {
  const mbps = estimateBitrateMbps(tp);
  if (!Number.isFinite(mbps)) return "";
  return `Geschaetzte Datenrate: ${mbps.toFixed(1)} Mbit/s (Schwellwert ${HIGH_BITRATE_THRESHOLD_MBPS} Mbit/s)`;
}

export { HIGH_BITRATE_THRESHOLD_MBPS };
